import { Tabs } from "@narmi/design_system";
import Filters from "byzantine/src/filters";
import { useNavigate } from "react-router-dom";
import { SettingsGroupPanel } from "./SettingsGroupGrid";

export const InstitutionSettingsTabList = ({
  institutionCategories,
  initialCategory,
  onCategoryChange,
}: {
  institutionCategories: string[];
  initialCategory?: string;
  onCategoryChange: (category: string) => void;
}) => {
  const navigate = useNavigate();
  const initialIndex = initialCategory
    ? Math.max(0, institutionCategories.indexOf(initialCategory))
    : 0;

  const handleTabChange = (index: number) => {
    const category = institutionCategories[index];
    if (category) {
      navigate(`/configuration/institution_settings/${category}`, { replace: true });
      onCategoryChange(category);
    }
  };

  return (
    <Tabs onTabChange={handleTabChange} selectedIndex={initialIndex}>
      <Tabs.List>
        {institutionCategories.map((category) => (
          <Tabs.Tab key={category} label={Filters.humanize(category)} tabId={category} />
        ))}
      </Tabs.List>
      {institutionCategories.map((category) => (
        <Tabs.Panel key={category} tabId={category} testId={`${category}-tab`}>
          <div className="padding--y--l">
            <SettingsGroupPanel category={category} />
          </div>
        </Tabs.Panel>
      ))}
    </Tabs>
  );
};
